import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Valida se o CPF tem exatamente 11 caracteres e se é um CPF válido
 * @param control O controle do formulário
 * @returns Um objeto com erro ou null se válido
 */
export function cpfValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Se vazio, deixa o Validators.required tratar
    }

    const cpf = control.value.replace(/\D/g, ''); // Remove caracteres não numéricos

    // Verifica se tem 11 caracteres
    if (cpf.length !== 11) {
      return { cpfNotValid: true };
    }

    // Verifica se todos os dígitos são iguais (CPFs inválidos conhecidos)
    if (/^(\d)\1{10}$/.test(cpf)) {
      return { cpfNotValid: true };
    }

    // Validação do algoritmo de CPF
    let sum = 0;
    let remainder: number;

    // Valida primeiro dígito verificador
    for (let i = 1; i <= 9; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10))) {
      return { cpfNotValid: true };
    }

    // Valida segundo dígito verificador
    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(10, 11))) {
      return { cpfNotValid: true };
    }

    return null; // CPF válido
  };
}
